import React from 'react';
import { Colors, FontSize } from '@common/tokens';

export const TotalCountLabel = ({
  dataLength,
  totalCount,
  label,
}: {
  dataLength: number;
  totalCount: number;
  label: string;
}) => (
  <>
    <div className="total-count-label">
      <p className="count-text">
        Viewing {dataLength} of {totalCount} {label}
      </p>
    </div>
    <style jsx>
      {`
        .total-count-label {
          margin-top: 14px;
          margin-bottom: 0;
        }
        .count-text {
          margin-bottom: 0;
          font-size: ${FontSize.xs};
          color: ${Colors.midnightLighter};
        }
      `}
    </style>
  </>
);
